<template>
  <div class="section__contents">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'ContentsArea',
}
</script>
